export default __webpack_public_path__ + "960d1895003e736c09dfe865a8052470.png";